<template>
  <re-auth :sid="sid" />
</template>

<script>
import ReAuth from '@/components/Auth/ReAuth'

export default {
  name: 'ReAuthView',
  props: {
    sid: {
      type: String,
      required: true
    }
  },
  components: {
    ReAuth
  }
}
</script>
